import axios from 'api';

// Super-admin dashboard cards — see DASHBOARD_API.md. Each card has its own
// endpoint so one slow or failing card doesn't hold up the others.
//
//   GET /api/super/dashboard/tenants/                                   §1
//   GET /api/super/tenants/?created_at__gte=…&created_at__lt=…          §2
//
// Session cookie is attached by the shared axios instance.
const BASE = '/api/super';

// Drops unset values so the backend applies its own defaults (today, both statuses).
const toQuery = (filters) => {
  const params = new URLSearchParams();
  Object.entries(filters || {}).forEach(([key, value]) => {
    if (value == null || value === '') return;
    params.set(key, value);
  });
  return params;
};

// Filters: date_from, date_to (YYYY-MM-DD, inclusive), tz (IANA), is_active.
export const getTenantSignups = (filters, signal) => axios.get(`${BASE}/dashboard/tenants/`, { params: toQuery(filters), signal });

// Filters: created_at__gte, created_at__lt (ISO 8601, UTC), is_active, get_all.
// With get_all the list comes back as a plain array — `unwrapList` handles both shapes.
export const getTenantsCreated = (filters, signal) => axios.get(`${BASE}/tenants/`, { params: toQuery(filters), signal });
